import React from 'react'
function ContactTwo() {
    return (
        <div>
            {/* start project with us section */}
            <div className="rts-project-area rts-section-gap bg-project-three margin-controlerproject mt_sm--0">
                <div className="container controler">
                    <div className="row g-0">
                        <div className="col-lg-7">
                            {/* project area left wrapper */}
                            <div className="title-area-project-w-in">
                                <span className="sub">Contactează-ne</span>
                                <h2 className="title">
                                    ÎNCEPE PROIECTUL <br /> <span>CU NOI!</span>
                                </h2>
                                <p className="disc">
                                    Izodrom Grup - partenerul dumneavoastră de încredere pentru infrastructură durabilă.{" "}
                                    <br /> Peste 20 de ani de expertiză în proiecte complexe de construcții și infrastructură.
                                </p>
                                <div className="bg-email">
                                    <div className="content-wrapper">
                                        {/* single-contact info */}
                                        <div className="contact-info">
                                            <div className="icon">
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/images/product/icon/01.jpg`}
                                                    alt="Phone_icon"
                                                />
                                            </div>
                                            <div className="discription">
                                                <span>Aveți nevoie de ajutor?</span>
                                                <h5 className="title-sm">+373 268 25-763</h5>
                                            </div>
                                        </div>
                                        {/* single-contact info End */}
                                        {/* single-contact info */}
                                        <div className="contact-info">
                                            <div className="icon">
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/images/product/icon/02.jpg`}
                                                    alt="Email_icon"
                                                />
                                            </div>
                                            <div className="discription">
                                                <span>Scrieți-ne oricând</span>
                                                <h5 className="title-sm">office@izodrom.md</h5>
                                            </div>
                                        </div>
                                        {/* single-contact info End */}
                                    </div>
                                </div>
                            </div>
                            {/* project area left wrapper end */}
                        </div>
                        <div className="col-lg-5">
                            <div className="bg-input-project">
                                <div className="product-form">
                                    <div id="form-messages" />
                                    <form id="contact-form">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <input
                                                    type="text"
                                                    placeholder="Numele și Prenumele"
                                                    name="name"
                                                    required=""
                                                />
                                            </div>
                                            <div className="col-lg-6 mt_md--20 mt_sm--20">
                                                <input
                                                    type="email"
                                                    placeholder="Adresa de Email"
                                                    name="email"
                                                    required=""
                                                />
                                            </div>
                                            <div className="col-12 mt--20">
                                                <input
                                                    type="text"
                                                    placeholder="Tipul de Proiect"
                                                    name="subject"
                                                />
                                            </div>
                                            <div className="col-12 mt--20">
                                                <textarea
                                                    placeholder="Descrierea proiectului sau mesajul dumneavoastră"
                                                    name="message"
                                                    defaultValue={""}
                                                />
                                            </div>
                                            <div className="col-12 mt--35">
                                                <button
                                                    className="rts-btn btn-primary-3 color-h-black"
                                                >
                                                    Trimite Mesajul
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* start project with us section End */}
        </div>
    )
}

export default ContactTwo